import * as R from 'ramda'
import dataAccessInstallClient from './dataAccess/installClient.js'
import productViewInstallClient from './productView/installClient.js'
import skuViewInstallClient from './skuView/installClient.js'
import queryViewInstallClient from './queryView/installClient.js'

export default R.pipe(
  dataAccessInstallClient,
  productViewInstallClient,
  skuViewInstallClient,
  queryViewInstallClient,
)
